import { create } from 'zustand';

export const useAuthStore = create((set) => ({
  user: null,
  isAuthenticated: false,
  authLoading: true,
  setAuth: (user) => set({ user, isAuthenticated: !!user, authLoading: false }),
  clearAuth: () => set({ user: null, isAuthenticated: false, authLoading: false }),
  setAuthLoading: (loading) => set({ authLoading: loading }),
}));
